export default {
  Circulars2024: 1,
  Circulars2017: 2
};